import { DialogActions } from '@mui/material';
import { BaseDialogActionsProps } from './BaseDialogActions.types';

/**
 * BaseDialogActions component that wraps the MUI DialogActions component.
 *
 * @param ariaLabel - {@link BaseDialogActionsProps.ariaLabel ariaLabel} description.
 * @param children - {@link BaseDialogActionsProps.children children} description.
 *
 */
export const BaseDialogActions = ({
    ariaLabel,
    children,
}: BaseDialogActionsProps) => {
    return (
        <DialogActions
            aria-label={ariaLabel}
        >
            {children}
        </DialogActions>
    );
};